/* Green Gorilla Fruits — FAQ accordion
 * --------------------------------------------------------------
 * Toggles aria-expanded on data-gg-faq-trigger / data-gg-faq-item.
 * The fallback uses native <details> so JS-disabled clients still
 * see the answers.
 */
(function () {
  'use strict';

  function bindItem(item) {
    const trigger = item.querySelector('[data-gg-faq-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const open = item.getAttribute('aria-expanded') === 'true';
      item.setAttribute('aria-expanded', open ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-gg-faq-item]').forEach(bindItem);
  });
})();
